export const sidebarMenu = [
    {
        "key": "Dashboard",
        "icon": 'dashboard-icon.svg',
        "onScreen": '/dashboard',
        "redirection": '/dashboard',
        "isVisibleFor": [2, 13]
    },
    {
        "key": "REQUESTS",
        "icon": 'reports-icon.svg',
        "onScreen": '/reports',
        "redirection": '/reports',
        "isVisibleFor": [5, 6]
    },
    {
        "key": "CONFIG",
        "icon": 'config-icon.svg',
        "onScreen": '/settings',
        "redirection": '/settings',
        "isVisibleFor": [9, 10, 11, 12]
    },
]